export const SAMPLE_CUSTOMER_NAME = 'Sarah';

export const REVIEW_LINK_PLACEHOLDER = '__REVIEW_LINK__';
export const BOOKING_PLACEHOLDER = '__BOOKING_SECTION__';

export const SMS_MAX_LENGTH = 150;

export const EMAIL_CTA_LABELS = Object.freeze({
  reviewRequest: 'Leave a Review',
  reviewReminder: 'Leave Your Review',
  booking: 'Book a Visit',
});

export const TEMPLATE_VARIABLES = ['customer_name', 'review_link', 'booking_link'];

export function getEmailCtaLabel(category, occurrence = 1) {
  if (String(category || '').toLowerCase().includes('review')) {
    return Number(occurrence) > 1
      ? EMAIL_CTA_LABELS.reviewReminder
      : EMAIL_CTA_LABELS.reviewRequest;
  }
  return EMAIL_CTA_LABELS.booking;
}

function formatBookingLinkPreview(bookingUrl, channel, rawLinks) {
  if (!bookingUrl) return '';
  if (rawLinks) {
    if (channel === 'sms' || channel === 'whatsapp') {
      return `Book now: ${bookingUrl}`;
    }
    return `Book your next visit now: ${bookingUrl}`;
  }
  return `${BOOKING_PLACEHOLDER}${bookingUrl}`;
}

export function fillPreviewVars(text, business, { rawLinks = false, customerName = SAMPLE_CUSTOMER_NAME, channel = 'email' } = {}) {
  if (!text) return '';
  const reviewUrl = business?.googleReviewLink || 'https://g.page/your-business/review';
  const bookingUrl = business?.bookingUrl || '';

  let result = text
    .replace(/\{\{customer_name\}\}/g, customerName)
    .replace(/\{\{name\}\}/g, customerName);

  if (rawLinks) {
    result = result
      .replace(/\{\{review_link\}\}/g, reviewUrl)
      .replace(/\{\{booking_link\}\}/g, formatBookingLinkPreview(bookingUrl, channel, true));
  } else {
    result = result
      .replace(/\{\{review_link\}\}/g, `${REVIEW_LINK_PLACEHOLDER}${reviewUrl}`)
      .replace(/\{\{booking_link\}\}/g, formatBookingLinkPreview(bookingUrl, channel, false));
  }

  return result;
}

export function displayTemplateBody(text) {
  return text || '';
}

export function getThemeGradient(color) {
  const base = /^#[0-9A-Fa-f]{6}$/.test(color || '') ? color : '#6C5CE7';
  const num = parseInt(base.slice(1), 16);
  const r = Math.min(255, Math.round(((num >> 16) & 0xff) + 255 * 0.15));
  const g = Math.min(255, Math.round(((num >> 8) & 0xff) + 255 * 0.15));
  const b = Math.min(255, Math.round((num & 0xff) + 255 * 0.15));
  const lighter = `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
  return `linear-gradient(135deg, ${base}, ${lighter})`;
}
